module.exports = __webpack_public_path__ + "static/media/down-arrow-big.8801ab70.svg";